import config from '@/config/prod.env';
import { header } from '@/helper/header';
import { common } from '@/helper/common';

export const hlvVanHoaService = {
    getDetail
};

async function getDetail(params, tableName){
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };
    return await fetch(`${config.API_URL}/${tableName}/GetDetail`, requestOptions).then(response => common.handleResponse(response));
}